import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./liquidity.scss";
import {
    callCrashGameGraphQLQuery,
} from "../../hooks/crashHooksdummy/axiosClient";
import { useCheckAllowance } from "../../hooks/dataSender/Allowance";
import {
    userSmartAccount,
    userSmartAccountClient,
    userSmartAccountUsdtBalance,
} from "../RecoilAtom";
import { useRecoilValue } from "recoil";
import {
    getGameLiquidityContract,
    getCrashGameContract
} from "../../utils/contractHelpers";
import {
    arbiscan_url,
    CRASH_GAME_CONTRACT,
    LIQUIDITY_CONTRACT,
    WHITE_LISTED_CRASHGAME_ADDRESSES,
} from "../../utils/Enviroment";
import { useSessionPermissions } from "../../hooks/checkSessionPermissions";
import useCrashDataFetcher from "../../hooks/dataFetcher/useCrashDataFetcher";
import CountdownTimerLiquidity from "./CountDownTimerLiquidity";
import Footer from "../landing/footer/Footer";
import { convertFromWei, formatSmartDecimal, formatNumbers, formatNumberWithCommasForRiskmarket } from "../../utils/helpers";
import { useGetAllBalances } from "../AllBalances";
import { Link, useNavigate } from "react-router-dom";
import LiquidityLoader from "../../hooks/liquidityLoader";
import { WHITELISTING_CHECK_TIME } from "../../utils/constants";
import { OverlayTrigger } from "react-bootstrap";
import TooltipCustom from "react-bootstrap/Tooltip";
import { useEoaAccount } from "../../hooks/useEoaAccount";
import { notifySuccess, notifyWarning } from "../Toast";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

const Liquidity = () => {
    const { t } = useTranslation();
    const {
        getMaxTrade,
        AddLiqudity,
        WithDrawHook,
        userClaimRewards,
        Unreserve,
        getCrashPlatformFee,
    } = useCrashDataFetcher();
    const smartAccount = useRecoilValue(userSmartAccount);
    const meClient = useRecoilValue(userSmartAccountClient);
    const { grantPermissions } = useSessionPermissions();
    const {
        checkAllowance,
        TotalRewards,
        CurrentLiquidityYouProvide,
        TotalYourReward,
        TotalShare,
        UserReserved,
        UserPrviewUnreserve
    } = useCheckAllowance();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [liquidityAmount, setLiquidityAmount] = useState("");
    const [errorState, setErrorState] = useState(false);
    const [errorStateRemove, setErrorStateRemove] = useState(false);
    const [removeUserLiquidity, setRemoveUserLiquidity] = useState("");
    const [userClaims, setUserClaims] = useState(0);
    const [withdrawalAmount, setWithdrawalAmount] = useState(null);
    const [index, setIndex] = useState(null);
    const [show1, setShow1] = useState(false);
    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);
    const [isTimerExpired, setIsTimerExpired] = useState(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loaderText, setLoaderText] = useState({
        heading: "Loading",
        paragraph: "",
    });
    const [userLiquidityShare, setUserLiquidityShare] = useState("");
    const [userLiquidityWorth, setUserLiquidityWorth] = useState(0);
    const [pendingWitdrawStatus, setPendingWithDrawStatus] = useState(false);
    const [pendingWitdrawAmount, setPendingWithDrawAmount] = useState(null);
    const [gameApy, setGameApy] = useState(0);
    const [show2, setShow2] = useState(false);
    const handleClose2 = () => {
        setShow2(false);
        setShow8(false);
        setTimeout(async () => {
            await fetchData();
            await fetchDepositedHistory();
            await fetchWithdrawldHistory();
            await fetchYourData();
        }, 3000);
    };
    const handleShow2 = () => setShow2(true);
    const [show3, setShow3] = useState(false);
    const handleClose3 = () => {
        setShow3(false)
    };
    const handleShow3 = () => setShow3(true);
    const [show4, setShow4] = useState(false);
    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);
    const [show5, setShow5] = useState(false);
    const handleClose5 = () => {
        setShow5(false);
        setShow8(false);
        setTimeout(async () => {
            await fetchData();
            await fetchDepositedHistory();
            await fetchWithdrawldHistory();
            await fetchYourData();
        }, 3000);
    };
    const handleShow5 = () => setShow5(true);

    const [show6, setShow6] = useState(false);
    const handleClose6 = () => {
        setShow6(false)
    };
    const handleShow6 = () => setShow6(true);

    const [show7, setShow7] = useState(false);
    const handleClose7 = () => setShow7(false);
    const handleShow7 = () => setShow7(true);

    const [show8, setShow8] = useState(false);
    const handleClose8 = () => {
        setShow8(false);
        setShow8(false);
        setTimeout(async () => {
            await fetchData();
            await fetchDepositedHistory();
            await fetchWithdrawldHistory();
            await fetchYourData();
        }, 3000);
    };
    const [show11, setShow11] = useState(false);
    const handleClose11 = () => setShow11(false);
    const handleShow11 = () => setShow11(true);
    const handleShow8 = () => setShow8(true);
    const [show9, setShow9] = useState(false);
    const handleClose9 = () => setShow9(false);
    const handleShow9 = () => setShow9(true);
    const [show10, setShow10] = useState(false);
    const handleClose10 = () => {
        setShow10(false);
        setShow8(false);
        setTimeout(async () => {
            await fetchData();
            await fetchDepositedHistory();
            await fetchWithdrawldHistory();
            await claimedRewardHandler();
            await fetchYourData();
        }, 3000);
    };
    const handleShow10 = () => setShow10(true);
    const [deposittedHistory, setDeposittedHistory] = useState([]);
    const [rewardsHistory, setRewardsHistory] = useState([]);
    const [withdrawlHistory, setWithdrawlHistory] = useState([]);
    const [totalUserWithdrawn, setTotalUserWithdrawn] = useState(0);
    const [allTimeDeposites, setAllTimeDeposites] = useState(0);
    const [currentLiquidity, setCurrentLiquidity] = useState(null);
    const [loading, setLoading] = useState(false);
    const [distributedRewards, setTotalDistributedRewards] = useState(null);
    const smartAccountUsdtBalance = useRecoilValue(userSmartAccountUsdtBalance);
    const getAllBalances = useGetAllBalances();
    const navigate = useNavigate()
    const { account } = useEoaAccount()

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         if (!smartAccount) {
    //             navigate("/");
    //         }
    //         else if (smartAccount && !WHITE_LISTED_CRASHGAME_ADDRESSES.includes(smartAccount)) {
    //             navigate("/");
    //         }
    //     }, WHITELISTING_CHECK_TIME);
    //     return () => clearTimeout(timer);
    // }, [smartAccount, navigate]);

    const fetchDepositedHistory = async () => {
        const query = `
    query MyQuery {
      deposits(orderDirection: desc, orderBy: blockTimestamp, where: {sender: "${smartAccount}"}) {
        sender
    receiver
    transactionHash
    assets
    blockTimestamp
    shares
    id
blockNumber
    asset
  }
    }`;

        try {
            const data = await callCrashGameGraphQLQuery(query);
            const updated = data.deposits;

            setDeposittedHistory(updated);
        } catch (error) {
            console.error("Failed to fetch bet history:", error);
        }
    };


    const fetchWithdrawldHistory = async () => {
        const query = `
    query MyQuery {
  withdraws(orderBy: blockTimestamp, orderDirection: desc, where: { sender: "${smartAccount}" }) {
    blockTimestamp
    sender
    transactionHash
     shares
    id
    assets
    blockNumber
    asset
  }
}`;

        try {
            const data = await callCrashGameGraphQLQuery(query);
            const updated = data?.withdraws;
            setWithdrawlHistory(updated);
        } catch (error) {
            console.error("Failed to fetch bet history: updated", error);
        }
    };

    const claimedRewardHandler = async () => {
        const query = `query MyQuery {
  liquidities(where: {user: "${smartAccount}"}) {
    asset
    id
    user
    allTimeWithdraws
    allTimeDeposits
  }
}`;
        try {
            const data = await callCrashGameGraphQLQuery(query);
            let updated = data?.liquidities[0].allTimeWithdraws;
            let allTimeWithdraws = data?.liquidities[0].allTimeDeposits;
            updated = convertFromWei(updated);
            allTimeWithdraws = convertFromWei(allTimeWithdraws);
            setTotalUserWithdrawn(updated);
            setAllTimeDeposites(allTimeWithdraws)
        } catch (error) {
            console.error("Failed to fetch bet history: updated", error);
        }
    };

    function formatTimestamp(unixSeconds) {
        const date = new Date(unixSeconds * 1000);
        const options = {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        };
        return date.toLocaleString("en-GB", options).replace(",", "");
    }

    function shortenAddress(address, chars = 4) {
        if (!address) return "";
        return `${address?.slice(0, 2 + chars)}...${address?.slice(-chars)}`;
    }

    const fetchData = async () => {
        try {
            const liquidity = await getMaxTrade(
                getGameLiquidityContract,
                LIQUIDITY_CONTRACT
            );
            const liquidityPlatformFee = await getCrashPlatformFee();
            setTotalDistributedRewards(liquidityPlatformFee);
            setCurrentLiquidity(liquidity);
        } catch (error) {
            console.error("Error fetching my reward data:", error);
        }
    };

    const fetchYourData = async () => {
        try {
            const userCurrentLiquidity = await CurrentLiquidityYouProvide(
                getGameLiquidityContract,
                LIQUIDITY_CONTRACT,
                smartAccount
            );
            const userReward = await TotalYourReward(
                getGameLiquidityContract,
                LIQUIDITY_CONTRACT,
                smartAccount,
                userCurrentLiquidity
            );
            const formattedclaimable =
                convertFromWei(userReward);
            setUserLiquidityShare(userCurrentLiquidity);
            setUserLiquidityWorth(formattedclaimable);

            const userReserve = await UserReserved(
                getGameLiquidityContract,
                LIQUIDITY_CONTRACT,
                smartAccount
            )
            const reservePreview = await UserPrviewUnreserve(
                getGameLiquidityContract,
                LIQUIDITY_CONTRACT,
                smartAccount
            )
            userReserve?.shares && setPendingWithDrawAmount(convertFromWei(userReserve?.shares, 'gwei'))
            reservePreview[0] && setPendingWithDrawStatus(reservePreview[0])
        } catch (error) {
            console.error("Error fetching user rewards data:", error);
        }
    };



    const handleAddLiquidity = async () => {
        setLoading(true);
        const betAmount = parseFloat(liquidityAmount);
        try {
            const liquidityAllowance = await checkAllowance(
                smartAccount,
                LIQUIDITY_CONTRACT
            );
            const { userPermissions: permissions, userSessionKey: sessionKey } =
                await grantPermissions();
            const needsApproval = liquidityAllowance < betAmount
            if (needsApproval) {
                setLoaderText({
                    heading: t("Approving your transaction"),
                    paragraph: t("Please approve transaction for making Deposit..."),
                });
                const liquidityTx = await AddLiqudity(
                    betAmount,
                    true,
                    smartAccount,
                    permissions,
                    sessionKey
                );
                setLoaderText({
                    heading: "",
                    paragraph: "",
                });
                setLoading(false);
                handleShow8();
                handleClose7();
                await getAllBalances();
                setLiquidityAmount("");
                return liquidityTx;
            } else {
                setLoaderText({
                    heading: t("Adding Liquidity"),
                    paragraph: t("Please wait while we add your liquidity..."),
                });
                await AddLiqudity(
                    betAmount,
                    false,
                    smartAccount,
                    permissions,
                    sessionKey
                );
                setLoaderText({
                    heading: "",
                    paragraph: "",
                });
                setLoading(false);
                handleShow8();
                handleClose7();
                await getAllBalances();
                setLiquidityAmount("");
            }
        } catch (error) {
            setLoaderText({
                heading: "",
                paragraph: "",
            });
            setLoading(false);
            console.error("Error placing bet:", error);
        }
    };

    const handleRemoveLiquidity = async () => {
        setLoading(true);
        const betAmount = parseFloat(removeUserLiquidity);
        try {
            setLoaderText({
                heading: t("Removing Liquidity"),
                paragraph: t("Please wait while we remove your liquidity..."),
            });
            const { userPermissions: permissions, userSessionKey: sessionKey } =
                await grantPermissions();
            await WithDrawHook(
                betAmount,
                false,
                smartAccount,
                permissions,
                sessionKey
            );
            setLoaderText({
                heading: "",
                paragraph: "",
            });
            setRemoveUserLiquidity("")
            await getAllBalances();
            setLoading(false);
            handleShow5();
            handleClose4();
        } catch (error) {
            setLoaderText({
                heading: "",
                paragraph: "",
            });
            setLoading(false);
            console.error("Error placing bet:", error);
        }
    };

    const handleClaimRewards = async () => {
        setLoading(true);
        try {
            setLoaderText({
                heading: t("Claiming Rewards"),
                paragraph: t("Please wait while we claim your rewards..."),
            });
            const { userPermissions: permissions, userSessionKey: sessionKey } =
                await grantPermissions();

            const claimRewardsTx = await userClaimRewards(
                smartAccount,
                permissions,
                sessionKey
            );
            setLoaderText({
                heading: "",
                paragraph: "",
            });
            if (claimRewardsTx) {
                setLoading(false);
                handleShow10();
                handleClose9();
            }
        } catch (error) {
            setLoaderText({
                heading: "",
                paragraph: "",
            });
            setLoading(false);
            console.error("Error placing bet:", error);
        }
    };


    const fetchPlayerBetHistory = async () => {
        const currentEpoch = Date.now() / 1000;
        const currentDate = new Date(currentEpoch * 1000);
        const startOfDay = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate()
        );
        const startOfDayEpoch = Math.floor(startOfDay.getTime() / 1000);
        const endOfDayEpoch = startOfDayEpoch + 86399;
        const placedBetsQuery = `
  query openPositionTerminations{
  openPositionTerminations(where: {    blockTimestamp_gte: "${startOfDayEpoch}",
    blockTimestamp_lte: "${endOfDayEpoch}"}) {
    amount
  }
}
  `;

        try {
            const data = await callCrashGameGraphQLQuery(placedBetsQuery);
            let addd = data.openPositionTerminations;
            const total = addd.reduce(
                (sum, item) => sum + parseInt(item.amount),
                0
            );
            const totalSharsValue = convertFromWei(total);
            setGameApy(totalSharsValue * 0.015 * 365);
        } catch (error) {
            console.error("Failed to fetch bet history:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        const initialData = async () => {
            await fetchDepositedHistory();
            await fetchWithdrawldHistory();
            await claimedRewardHandler();
            await fetchYourData();
        };
        if (smartAccount) {
            initialData();
        }
    }, [smartAccount]);

    useEffect(() => {
        const initialData = async () => {
            await fetchData();
            await fetchPlayerBetHistory();
        };
        initialData();
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const unreserved = async () => {
        setLoading(true);
        try {
            setLoaderText({
                heading: t("Withdrawing Pending Funds"),
                paragraph: t("Please wait while we withdraw your funds..."),
            });
            const { userPermissions: permissions, userSessionKey: sessionKey } =
                await grantPermissions();

            const claimRewardsTx = await Unreserve(
                smartAccount,
                permissions,
                sessionKey
            );
            setLoaderText({
                heading: "",
                paragraph: "",
            });
            if (claimRewardsTx) {
                await fetchData();
                await fetchDepositedHistory();
                await fetchWithdrawldHistory();
                await fetchYourData();
                handleClose1()
                handleShow2()
                setLoading(false);
            }
        } catch (error) {
            setLoaderText({
                heading: "",
                paragraph: "",
            });
            setLoading(false);
            console.error("Error placing bet:", error);
        }
    }

    useEffect(() => {
        if (pendingWitdrawAmount > 0) {
            addingPendingWithdraw()
        }
    }, [pendingWitdrawAmount, pendingWitdrawStatus
    ])

    const addingPendingWithdraw = async () => {
        const query = `query MyQuery {
  withdrawalReserveds(
    where: {sender: "${smartAccount}"}
    orderBy: blockTimestamp
    orderDirection: desc
  ) {
    transactionHash
    shares
    sender
    id
    fees
    blockTimestamp
    blockNumber
    assets
    asset
    activeQueueLength
    receiver
  }
}`;
        let data = await callCrashGameGraphQLQuery(query);
        data = data?.withdrawalReserveds[0]
        setWithdrawlHistory(prevItems => [data, ...prevItems])

        try {

        } catch (err) {
            console.log(err, 'error in while checking pendign withdraw');

        }
    }

    return (
        <>
            <Helmet>
                <link
                    rel="canonical"
                    href="https://www.riskmarkets.fun/liquidity"
                />
            </Helmet>
            {loading && <LiquidityLoader text={loaderText} />}
            <div className="custom-container">
                <section className="liquidity_main">
                    <h6 className="moonhead">
                        <Link to="/">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M11.2899 6.28982L6.2899 11.2898C6.19886 11.3849 6.12749 11.4971 6.0799 11.6198C5.97988 11.8633 5.97988 12.1364 6.0799 12.3798C6.12749 12.5026 6.19886 12.6147 6.2899 12.7098L11.2899 17.7098C11.3831 17.8031 11.4938 17.877 11.6156 17.9275C11.7375 17.9779 11.868 18.0039 11.9999 18.0039C12.2662 18.0039 12.5216 17.8981 12.7099 17.7098C12.8982 17.5215 13.004 17.2661 13.004 16.9998C13.004 16.7335 12.8982 16.4781 12.7099 16.2898L9.4099 12.9998L16.9999 12.9998C17.2651 12.9998 17.5195 12.8945 17.707 12.7069C17.8945 12.5194 17.9999 12.265 17.9999 11.9998C17.9999 11.7346 17.8945 11.4802 17.707 11.2927C17.5195 11.1052 17.2651 10.9998 16.9999 10.9998L9.4099 10.9998L12.7099 7.70981C12.8036 7.61685 12.878 7.50625 12.9288 7.38439C12.9796 7.26253 13.0057 7.13183 13.0057 6.99982C13.0057 6.8678 12.9796 6.7371 12.9288 6.61524C12.878 6.49338 12.8036 6.38278 12.7099 6.28982C12.6169 6.19609 12.5063 6.12169 12.3845 6.07092C12.2626 6.02015 12.1319 5.99402 11.9999 5.99402C11.8679 5.99402 11.7372 6.02015 11.6153 6.07092C11.4935 6.12169 11.3829 6.19609 11.2899 6.28982Z" fill="#212121" />
                            </svg> {t('Back')}
                        </Link>
                    </h6>
                    <div className="inner_main">
                        <div className="left_side">
                            <div className="left_top">
                                <div className="inner_left_side">
                                    {window.innerWidth > 600 ? <h2>{t('Total Pool Liquidity')}</h2> : <h2>{t('Total Liquidity')}</h2>}
                                    <h3>${formatSmartDecimal(+currentLiquidity)}</h3>
                                </div>
                                <div className="inner_right_side">
                                    {window.innerWidth > 600 ? <h2>{t('Total Distributed Rewards')}</h2> : <h2>{t('Total Reward')}</h2>}

                                    <h3>${formatSmartDecimal(+distributedRewards)}</h3>
                                </div>
                                <div className="inner_right_side">
                                    <h2>{t('Estimated APY')} <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                <h6>{t('Estimated APY')}</h6>
                                                <p>{t('Annual Percentage Yield, Actual returns may vary.')}</p>
                                            </TooltipCustom>
                                        }
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <g clip-path="url(#clip0_10136_49160)">
                                                <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_10136_49160">
                                                    <rect width="14" height="14" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </OverlayTrigger></h2>
                                    <h3> {gameApy > 0 ? `${formatNumberWithCommasForRiskmarket(+gameApy)}` : "0"}%</h3>
                                </div>
                            </div>
                            <div className="flow_mains">
                                <div>
                                    <h4>{t('Liquidity Participation')}</h4>
                                    <p>
                                        {t('Provide liquidity to support market operations and receive protocol-distributed rewards.')}
                                    </p>
                                </div>
                                <div className="parents_innar">
                                    <div className="inar">
                                        <h5>{t('Liquidity Shares')}
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                        <h6>{t('Liquidity Provided')}</h6>
                                                        <p>{t('The amount of shares you hold in the liquidity pool, based on the liquidity amount you provided.')}</p>
                                                    </TooltipCustom>
                                                }
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_10136_49160)">
                                                        <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_10136_49160">
                                                            <rect width="14" height="14" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </OverlayTrigger>
                                        </h5>
                                        <h6>
                                            {userLiquidityShare > 0 ? `${formatNumberWithCommasForRiskmarket(+userLiquidityShare)}` : "0"}
                                        </h6>
                                    </div>
                                    <div className="inar">
                                        <h5>{t('Liquidity Worth')}
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                        <h6>{t('Liquidity Worth')}</h6>
                                                        <p>{t('The current value of your liquidity, based on the total liquidity available at the moment.')}</p>
                                                    </TooltipCustom>
                                                }
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_10136_49160)">
                                                        <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_10136_49160">
                                                            <rect width="14" height="14" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </OverlayTrigger>
                                        </h5>
                                        <h6>
                                            {userLiquidityWorth > 0 ? `$${formatNumberWithCommasForRiskmarket(+userLiquidityWorth)}` : "0"}
                                        </h6>
                                    </div>
                                    <div className="inar">
                                        <h5>{t('Withdrawn')}</h5>
                                        <h6>
                                            {totalUserWithdrawn > 0 ? `$${formatNumberWithCommasForRiskmarket(totalUserWithdrawn)}` : "0"}
                                        </h6>
                                    </div>
                                    <div className="inar">
                                        <h5>{t('Deposits')}</h5>
                                        <h6>
                                            {allTimeDeposites > 0 ? `$${formatNumberWithCommasForRiskmarket(allTimeDeposites)}` : "0"}
                                        </h6>
                                    </div>
                                    {/* <div className="inar">
                                        <h5>{t('Estimated APY')}
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                        <h6>{t('Estimated APY')}</h6>
                                                        <p>{t('The estimated annual percentage yield of the liquidity pool. Actual returns may vary according to market outcomes.')}</p>
                                                    </TooltipCustom>
                                                }
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_10136_49160)">
                                                        <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_10136_49160">
                                                            <rect width="14" height="14" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </OverlayTrigger>
                                        </h5>
                                        <h6> {gameApy > 0 ? `${formatNumberWithCommasForRiskmarket(+gameApy)}` : "0"}%</h6>
                                    </div> */}
                                    {/* <div className="inar">
                                        <h5>Current position</h5>
                                        <h6> {userLiquidityWorth ? formatNumberWithCommas(+userLiquidityWorth) : "0"}</h6>
                                    </div>
                                    <div className="inar">
                                        <h5>Unrealized PnL </h5>
                                        <h6> {gameApy ? `${formatNumberWithCommas(+gameApy)}%` : "0"}</h6>
                                    </div> */}
                                </div>
                                <div className="butttonsdiv" style={!account ? { gridTemplateColumns: "1fr" } : { gridTemplateColumns: "1fr 1fr" }}>
                                    {account && (
                                        <button className={userLiquidityShare <= 0 || pendingWitdrawAmount > 0 ? "removebutton removebuttonhoverstate" : "removebutton"} onClick={handleShow3}
                                            disabled={userLiquidityShare <= 0 || pendingWitdrawAmount > 0 ? true : false}
                                        >
                                            {t('Withdraw My Liquidity')}
                                            <div className="tooltip-btn-custom">
                                                {
                                                    pendingWitdrawAmount > 0 ? <>{t('You can request a new withdrawal only after your current withdrawal is claimed. Pending withdrawals must be completed before submitting another.')}</>
                                                        : <>{t('You currently have no liquidity in this market to withdraw.')}</>
                                                }

                                            </div>
                                        </button>
                                    )}
                                    {account ? (
                                        <>
                                            <button className={smartAccountUsdtBalance <= 0 ? "addbutton addbuttonhoverstate" : "addbutton"} onClick={handleShow6}
                                                disabled={smartAccountUsdtBalance <= 0 ? true : false}
                                            >
                                                {t('Add Liquidity')}
                                                <div className="tooltip-btn-custom">
                                                    {
                                                        smartAccountUsdtBalance <= 0 && <>{t('You have no available balance to add liquidity at the moment.')} </>
                                                    }

                                                </div>
                                            </button>
                                        </>
                                    ) : (
                                        <button
                                            disabled
                                            onClick={handleShow11}
                                            className="claimbutton"
                                        >
                                            {t('Please connect your wallet')}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="right__side">
                            <h2>{t('History')}</h2>
                            <div>
                                <nav className="navsectiontabs">
                                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                        <button
                                            class="nav-link active"
                                            id="nav-home-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#nav-home"
                                            type="button"
                                            role="tab"
                                            aria-controls="nav-home"
                                            aria-selected="true"
                                        >
                                            {t('Liquidity Deposits')}
                                        </button>
                                        <button
                                            class="nav-link"
                                            id="nav-contact-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#nav-contact"
                                            type="button"
                                            role="tab"
                                            aria-controls="nav-contact"
                                            aria-selected="false"
                                        >
                                            {t('Liquidity Withdrawals')}{" "}
                                        </button>
                                    </div>
                                </nav>
                                <div class="tab-content" id="nav-tabContent">
                                    <div
                                        class="tab-pane fade show active"
                                        id="nav-home"
                                        role="tabpanel"
                                        aria-labelledby="nav-home-tab"
                                    >
                                        <div className="table_side">
                                            {window.innerWidth > 991 ? (
                                                <div className="history-section">
                                                    <div className="parent">
                                                        <div className="upper-fields">
                                                            <p>{t('Timestamp')}</p>
                                                            <p>{t('Transaction ID')}</p>
                                                            <p>{t('Amount')}</p>
                                                        </div>

                                                        <div
                                                            className="bottom-fields"
                                                            style={{ minHeight: "400px" }}
                                                        >
                                                            {account ? (
                                                                deposittedHistory &&
                                                                    deposittedHistory.length > 0 ? (
                                                                    deposittedHistory.map((row, index) => (
                                                                        <div className="single-field" key={index}>
                                                                            <h6>
                                                                                {formatTimestamp(row?.blockTimestamp)}
                                                                            </h6>

                                                                            <a
                                                                                href={`${arbiscan_url}/${row?.transactionHash}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                {shortenAddress(row?.transactionHash)}
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="12"
                                                                                    height="12"
                                                                                    viewBox="0 0 12 12"
                                                                                    fill="none"
                                                                                >
                                                                                    <path
                                                                                        d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                                                                                        stroke="#797979"
                                                                                        strokeWidth="1.04"
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                    />
                                                                                    <path
                                                                                        d="M10.5 1.5L6 6"
                                                                                        stroke="#797979"
                                                                                        strokeWidth="1.04"
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                    />
                                                                                    <path
                                                                                        d="M7.5 1.5H10.5V4.5"
                                                                                        stroke="#797979"
                                                                                        strokeWidth="1.04"
                                                                                        strokeLinecap="round"
                                                                                        strokeLinejoin="round"
                                                                                    />
                                                                                </svg>
                                                                            </a>

                                                                            <h6>
                                                                                $
                                                                                {formatSmartDecimal(
                                                                                    +convertFromWei(row?.assets)
                                                                                )}
                                                                            </h6>
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <p className="no-data-text">
                                                                        {t('No Liquidity Deposits Yet')}
                                                                    </p>
                                                                )
                                                            ) : (
                                                                <p className="no-data-text">
                                                                    {t('You Haven’t Connect Your Wallet Yet')}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="history-section-mbl">
                                                    <div className="parent-cards">
                                                        {account ? (
                                                            deposittedHistory &&
                                                                deposittedHistory.length > 0 ? (
                                                                deposittedHistory.map((row, index) => (
                                                                    <div className="single-card" key={index}>
                                                                        <div className="text">
                                                                            <p>{t('Timestamp')}</p>
                                                                            <h6>
                                                                                {formatTimestamp(row?.blockTimestamp)}
                                                                            </h6>
                                                                        </div>

                                                                        <div className="text">
                                                                            <p>{t('Transaction ID')}</p>
                                                                            <a
                                                                                href={`${arbiscan_url}/${row?.transactionHash}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                {shortenAddress(row?.transactionHash)}
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                                    <g clip-path="url(#clip0_7547_5119)">
                                                                                        <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M10.5 1.5L6 6" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M7.5 1.5H10.5V4.5" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </g>
                                                                                    <defs>
                                                                                        <clipPath id="clip0_7547_5119">
                                                                                            <rect width="12" height="12" fill="white" />
                                                                                        </clipPath>
                                                                                    </defs>
                                                                                </svg>
                                                                            </a>
                                                                        </div>

                                                                        <div className="text">
                                                                            <p>{t('Amount')}</p>
                                                                            <h6>
                                                                                $
                                                                                {formatSmartDecimal(
                                                                                    +convertFromWei(row?.assets)
                                                                                )}
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p className="no-data-text">
                                                                    {t('No Liquidity Deposits Yet')}
                                                                </p>
                                                            )
                                                        ) : (
                                                            <p className="no-data-text">
                                                                {t('You Haven’t Connect Your Wallet Yet')}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        class="tab-pane fade"
                                        id="nav-profile"
                                        role="tabpanel"
                                        aria-labelledby="nav-profile-tab"
                                    >
                                        <div className="table_side">
                                            {window.innerWidth > 991 ? (
                                                <div className="history-section">
                                                    <div className="parent">
                                                        <div className="upper-fields">
                                                            <p>{t('Timestamp')}</p>
                                                            <p>{t('Transaction ID')}</p>
                                                            <p>{t('Amount')}</p>
                                                        </div>

                                                        <div
                                                            className="bottom-fields"
                                                            style={{ minHeight: "400px" }}
                                                        >
                                                            {account ? (
                                                                rewardsHistory && rewardsHistory.length > 0 ? (
                                                                    rewardsHistory.map((reward, index) => (
                                                                        <div className="single-field" key={index}>
                                                                            <h6>
                                                                                {formatTimestamp(
                                                                                    reward?.blockTimestamp
                                                                                )}
                                                                            </h6>

                                                                            <a
                                                                                href={`${arbiscan_url}/${reward?.transactionHash}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                {shortenAddress(
                                                                                    reward?.transactionHash
                                                                                )}
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                                    <g clip-path="url(#clip0_7547_5119)">
                                                                                        <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M10.5 1.5L6 6" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M7.5 1.5H10.5V4.5" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </g>
                                                                                    <defs>
                                                                                        <clipPath id="clip0_7547_5119">
                                                                                            <rect width="12" height="12" fill="white" />
                                                                                        </clipPath>
                                                                                    </defs>
                                                                                </svg>
                                                                            </a>

                                                                            <h6>
                                                                                {formatSmartDecimal(
                                                                                    +convertFromWei(reward?.amount)
                                                                                )}{" "}
                                                                                USDT
                                                                            </h6>
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <div className="connectwalletmain w-100">
                                                                        <span className="mainimg">
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="38"
                                                                                height="38"
                                                                                fill="none"
                                                                            >
                                                                                <path
                                                                                    d="M3.16 3.16L34.83 34.83"
                                                                                    stroke="#F24CA2"
                                                                                    strokeWidth="2"
                                                                                    strokeLinecap="round"
                                                                                />
                                                                                <path
                                                                                    d="M13.21 4.25C16.08 3.14 19.21 2.88 22.22 3.51C25.24 4.14 28 5.63 30.17 7.81C32.35 9.99 33.84 12.75 34.47 15.76C35.1 18.78 34.84 21.91 33.72 24.77"
                                                                                    stroke="#F24CA2"
                                                                                    strokeWidth="2"
                                                                                    strokeLinecap="round"
                                                                                />
                                                                                <path
                                                                                    d="M30.21 30.21C28.73 31.68 26.99 32.85 25.06 33.64C23.14 34.44 21.08 34.85 19 34.85C16.91 34.85 14.85 34.44 12.93 33.64C11.01 32.85 9.26 31.68 7.79 30.21C6.31 28.73 5.15 26.99 4.35 25.06C3.55 23.14 3.14 21.08 3.14 19C3.14 16.91 3.55 14.85 4.35 12.93C5.15 11.01 6.31 9.26 7.79 7.79"
                                                                                    stroke="#F24CA2"
                                                                                    strokeWidth="2"
                                                                                    strokeLinecap="round"
                                                                                />
                                                                            </svg>
                                                                        </span>
                                                                        <h6 className="connecthead">
                                                                            {t('You Haven’t Claimed Any Rewards Yet')}
                                                                        </h6>
                                                                        <p className="connectpara">
                                                                            {t('Your claimed rewards will show up here')}
                                                                        </p>
                                                                    </div>
                                                                )
                                                            ) : (
                                                                <div className="connectwalletmain w-100">
                                                                    <span className="mainimg">
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="38"
                                                                            height="38"
                                                                            fill="none"
                                                                        >
                                                                            <path
                                                                                d="M30.083 11.083V6.333C30.083 5.913 29.916 5.510 29.619 5.213C29.322 4.916 28.919 4.75 28.5 4.75H7.916C7.076 4.75 6.271 5.083 5.677 5.677C5.083 6.271 4.75 7.076 4.75 7.916C4.75 8.756 5.083 9.561 5.677 10.155C6.271 10.749 7.076 11.083 7.916 11.083H31.666C32.086 11.083 32.489 11.250 32.786 11.547C33.083 11.844 33.25 12.246 33.25 12.666V19"
                                                                                stroke="#F24CA2"
                                                                                strokeWidth="1.5"
                                                                                strokeLinecap="round"
                                                                            />
                                                                            <path
                                                                                d="M4.75 7.916V30.083C4.75 30.923 5.083 31.728 5.677 32.322C6.271 32.916 7.076 33.249 7.916 33.249H31.666C32.086 33.249 32.489 33.083 32.786 32.786C33.083 32.489 33.25 32.086 33.25 31.666V25.333"
                                                                                stroke="#F24CA2"
                                                                                strokeWidth="1.5"
                                                                                strokeLinecap="round"
                                                                            />
                                                                        </svg>
                                                                    </span>
                                                                    <h6 className="connecthead">
                                                                        {t('You Haven’t Connect Your Wallet Yet')}
                                                                    </h6>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="history-section-mbl">
                                                    <div className="parent-cards">
                                                        {rewardsHistory?.map((reward, index) => (
                                                            <div className="single-card" key={index}>
                                                                <div className="text">
                                                                    <p>{t('Timestamp')}</p>
                                                                    <h6>
                                                                        {formatTimestamp(reward?.blockTimestamp)}
                                                                    </h6>
                                                                </div>

                                                                <div className="text">
                                                                    <p>{t('Transaction ID')}</p>
                                                                    <a
                                                                        href={`${arbiscan_url}/${reward?.transactionHash}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {shortenAddress(reward?.transactionHash)}
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                            <g clip-path="url(#clip0_7547_5119)">
                                                                                <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M10.5 1.5L6 6" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M7.5 1.5H10.5V4.5" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </g>
                                                                            <defs>
                                                                                <clipPath id="clip0_7547_5119">
                                                                                    <rect width="12" height="12" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>
                                                                    </a>
                                                                </div>

                                                                <div className="text">
                                                                    <p>{t('Amount')}</p>
                                                                    <h6>
                                                                        {formatSmartDecimal(
                                                                            +convertFromWei(reward?.amount)
                                                                        )}{" "}
                                                                        USDT
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        class="tab-pane fade"
                                        id="nav-contact"
                                        role="tabpanel"
                                        aria-labelledby="nav-contact-tab"
                                    >
                                        <div className="table_side">
                                            {window.innerWidth > 991 ? (
                                                <div className="history-section">
                                                    <div className="parent">
                                                        <div className="upper-fields">
                                                            <p>{t('Timestamp')}</p>
                                                            <p>{t('Transaction ID')}</p>
                                                            <p>{t('Withdrawal Amount')}</p>
                                                            <p>{t('Withdrawal Status')}</p>

                                                        </div>

                                                        <div
                                                            className="bottom-fields"
                                                            style={{ minHeight: "400px" }}
                                                        >
                                                            {/* ---------------- NO WALLET CONNECTED ---------------- */}
                                                            {!account ? (
                                                                <p className="no-data-text">
                                                                    {t('You Haven’t Connect Your Wallet Yet')}
                                                                </p>
                                                            ) : !withdrawlHistory ||
                                                                withdrawlHistory.length === 0 ? (
                                                                <p className="no-data-text">
                                                                    {t('You Haven’t Withdrawn Any Liquidity Yet')}
                                                                </p>
                                                            ) : (
                                                                withdrawlHistory.map((row, index) => {
                                                                    const unlockTime =
                                                                        parseInt(row.blockTimestamp) + 120;
                                                                    const now = Math.floor(Date.now() / 1000);
                                                                    const locked =
                                                                        now < unlockTime && !isTimerExpired;

                                                                    return (
                                                                        <div className="single-field" key={index}>
                                                                            {/* DATE */}
                                                                            <h6>
                                                                                {formatTimestamp(row.blockTimestamp)}
                                                                            </h6>

                                                                            {/* TX HASH */}
                                                                            <a
                                                                                href={`${arbiscan_url}/${row.transactionHash}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                {shortenAddress(row.transactionHash)}
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                                    <g clip-path="url(#clip0_7547_5119)">
                                                                                        <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M10.5 1.5L6 6" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M7.5 1.5H10.5V4.5" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </g>
                                                                                    <defs>
                                                                                        <clipPath id="clip0_7547_5119">
                                                                                            <rect width="12" height="12" fill="white" />
                                                                                        </clipPath>
                                                                                    </defs>
                                                                                </svg>
                                                                            </a>

                                                                            {/* AMOUNT */}
                                                                            <h6>
                                                                                $
                                                                                {formatSmartDecimal(
                                                                                    +convertFromWei(row?.assets)
                                                                                )}
                                                                            </h6>
                                                                            <div>
                                                                                {row?.activeQueueLength && locked ? (
                                                                                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                                                        <CountdownTimerLiquidity
                                                                                            setIsTimerExpired={
                                                                                                setIsTimerExpired
                                                                                            }
                                                                                            epochTime={unlockTime}
                                                                                        />
                                                                                        <OverlayTrigger
                                                                                            placement="top"
                                                                                            overlay={
                                                                                                <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                                                                    <p>{t('Your withdrawal is pending because the round is still active. You’ll be able to claim it once the round finishes.')}</p>
                                                                                                </TooltipCustom>
                                                                                            }
                                                                                        >
                                                                                            <svg style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                                <g clip-path="url(#clip0_10136_49160)">
                                                                                                    <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                    <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                    <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                </g>
                                                                                                <defs>
                                                                                                    <clipPath id="clip0_10136_49160">
                                                                                                        <rect width="14" height="14" fill="white" />
                                                                                                    </clipPath>
                                                                                                </defs>
                                                                                            </svg>
                                                                                        </OverlayTrigger>
                                                                                    </div>
                                                                                ) : row?.activeQueueLength ? (
                                                                                    <button
                                                                                        className="purple_button"
                                                                                        onClick={() =>
                                                                                            handleShow(row.index, row.amount)
                                                                                        }
                                                                                    >
                                                                                        {t('Withdraw')}
                                                                                    </button>
                                                                                ) : (
                                                                                    <button className="simple_button">
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                            <path d="M11.6673 3.5L5.25065 9.91667L2.33398 7" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        </svg>
                                                                                        {t('Withdrawn')}
                                                                                    </button>
                                                                                )}
                                                                            </div>

                                                                        </div>
                                                                    );
                                                                })
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="history-section-mbl">
                                                    <div className="parent-cards">
                                                        {/* NO WALLET */}
                                                        {!account ? (
                                                            <p className="no-data-text">
                                                                {t('You Haven’t Connect Your Wallet Yet')}
                                                            </p>
                                                        ) : !withdrawlHistory ||
                                                            withdrawlHistory.length === 0 ? (
                                                            <p className="no-data-text">
                                                                {t('You Haven’t Withdrawn Any Liquidity Yet')}
                                                            </p>
                                                        ) : (
                                                            withdrawlHistory.map((row, index) => {
                                                                const unlockTime =
                                                                    parseInt(row.blockTimestamp) + 120;
                                                                const now = Math.floor(Date.now() / 1000);
                                                                const locked =
                                                                    now < unlockTime && !isTimerExpired;

                                                                return (
                                                                    <div className="single-card" key={index}>
                                                                        <div className="text">
                                                                            <p>{t('Timestamp')}</p>
                                                                            <h6>
                                                                                {formatTimestamp(row.blockTimestamp)}
                                                                            </h6>
                                                                        </div>

                                                                        <div className="text">
                                                                            <p>{t('Transaction ID')}</p>
                                                                            <a
                                                                                href={`${arbiscan_url}/${row.transactionHash}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                {shortenAddress(row.transactionHash)}
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                                    <g clip-path="url(#clip0_7547_5119)">
                                                                                        <path d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M10.5 1.5L6 6" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        <path d="M7.5 1.5H10.5V4.5" stroke="#797979" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </g>
                                                                                    <defs>
                                                                                        <clipPath id="clip0_7547_5119">
                                                                                            <rect width="12" height="12" fill="white" />
                                                                                        </clipPath>
                                                                                    </defs>
                                                                                </svg>
                                                                            </a>
                                                                        </div>

                                                                        <div className="text">
                                                                            <p>{t('Withdrawal Amount')}</p>
                                                                            <h6>
                                                                                $
                                                                                {formatSmartDecimal(
                                                                                    +convertFromWei(row?.assets)
                                                                                )}
                                                                            </h6>
                                                                        </div>
                                                                        <div className="text">
                                                                            <p>{t('Withdrawal Status')}</p>

                                                                            {row?.activeQueueLength && locked ? (
                                                                                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                                                    <CountdownTimerLiquidity
                                                                                        setIsTimerExpired={
                                                                                            setIsTimerExpired
                                                                                        }
                                                                                        epochTime={unlockTime}
                                                                                    />
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={
                                                                                            <TooltipCustom className="liquidity-provided-tooltip" id="tooltip-1">
                                                                                                <p>{t('Your withdrawal is pending because the round is still active. You’ll be able to claim it once the round finishes.')}</p>
                                                                                            </TooltipCustom>
                                                                                        }
                                                                                    >
                                                                                        <svg style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                            <g clip-path="url(#clip0_10136_49160)">
                                                                                                <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                <path d="M7 9.33333V7" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                <path d="M7 4.6665H7.01" stroke="#9F9F9F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            </g>
                                                                                            <defs>
                                                                                                <clipPath id="clip0_10136_49160">
                                                                                                    <rect width="14" height="14" fill="white" />
                                                                                                </clipPath>
                                                                                            </defs>
                                                                                        </svg>
                                                                                    </OverlayTrigger>
                                                                                </div>
                                                                            ) : row?.activeQueueLength ? (
                                                                                <button
                                                                                    className="purple_button"
                                                                                    onClick={() =>
                                                                                        handleShow(row.index, row.amount)
                                                                                    }
                                                                                >
                                                                                    {t('Withdraw')}
                                                                                </button>
                                                                            ) : (
                                                                                <button className="simple_button">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                        <path d="M11.6673 3.5L5.25065 9.91667L2.33398 7" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </svg>
                                                                                    {t('Withdrawn')}
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
            <Modal className="token" show={show} onHide={handleClose} centered backdrop="static"
                keyboard={false}>
                <Modal.Header >
                    <Modal.Title>{t('Confirm Liquidity Withdrawal')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal">
                        <div className="inner_side_modal">
                            <h2>{t('Withdrawal Amount')}</h2>
                            <h3>
                                {pendingWitdrawAmount}
                            </h3>
                        </div>
                        <div className="inner_side_modal1">
                            <button
                                className="close"
                                onClick={() => {
                                    handleClose();
                                }}
                            >
                                {t('Close')}
                            </button>
                            <button
                                className="Withdraw setbtnsizembl"
                                onClick={() => {
                                    handleShow1();
                                    handleClose();
                                }}
                            >
                                {t('Confirm')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                className="token"
                show={show2}
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header >
                    <Modal.Title>{t('Withdrawal Completed')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img success-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="47"
                                    height="47"
                                    viewBox="0 0 47 47"
                                    fill="none"
                                >
                                    <path
                                        d="M39.063 11.7188L17.5795 33.2023L7.81421 23.4371"
                                        stroke="white"
                                        stroke-width="2.70423"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                            <h2>{t('Liquidity Withdrawal Completed')}</h2>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={handleClose2}>
                                {t('Done')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token" show={show3} onHide={handleClose3} centered backdrop="static"
                keyboard={false} >
                <Modal.Header >
                    <Modal.Title>{t('Request Liquidity Withdrawal')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="new_modals">
                            <div className="liquid_textt">
                                <h2>{t('Withdrawal Amount')}</h2>
                                <h2>
                                    {t('Available for Withdrawal')}:{" "}
                                    <span>{(+userLiquidityShare)?.toFixed(4)}</span>
                                </h2>
                            </div>
                            <div className="option-field">
                                <input
                                    className={+removeUserLiquidity > +userLiquidityShare && "error"}
                                    value={removeUserLiquidity}
                                    placeholder="$0.00"
                                    type="number"
                                    id="fname"
                                    name="fname"
                                    onChange={(e) => setRemoveUserLiquidity(e.target.value)}
                                // className="error"
                                />
                                <a href="#" className="btn-max" onClick={() => { setRemoveUserLiquidity(userLiquidityShare); }}>{t('MAX')}</a>
                            </div>

                            {+removeUserLiquidity > +userLiquidityShare ? (
                                <h4
                                    style={{
                                        color: "var(--logout-text1)",
                                        fontSize: "12px",
                                        fontFamily: "hbold",
                                        lineHeight: "100%"
                                    }}
                                >
                                    {/* Amount is 0 or Greater Than Available liquidity */}
                                    {t('Amount exceeds available liquidity')}
                                </h4>
                            ) : (
                                ""
                            )}
                            {/* <h5>
                                If a round is in progress, your funds will be available for withdrawal after a 2-minute lock-in period. Otherwise, they will be made available to you directly.
                            </h5> */}
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={() => {
                                handleClose3()
                                setRemoveUserLiquidity('')
                            }}>
                                {t('Close')}
                            </button>
                            <button
                                className="remove setbtnsizembl"
                                disabled={+removeUserLiquidity > +userLiquidityShare ||
                                    removeUserLiquidity <= 0 ? true : false}
                                onClick={() => {

                                    handleShow4();
                                    handleClose3();

                                }}
                            >
                                {t('Request Withdrawal')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token" show={show4} onHide={handleClose4} centered backdrop="static"
                keyboard={false}>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img">
                                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                    <path d="M33 14.5C33 19.4002 28.7942 23.4564 23.375 24.0494V27.875C23.375 28.2397 23.2301 28.5894 22.9723 28.8473C22.7144 29.1051 22.3647 29.25 22 29.25C21.6353 29.25 21.2856 29.1051 21.0277 28.8473C20.7699 28.5894 20.625 28.2397 20.625 27.875V22.75C20.625 22.3853 20.7699 22.0356 21.0277 21.7777C21.2856 21.5199 21.6353 21.375 22 21.375C26.5495 21.375 30.25 18.2916 30.25 14.5C30.25 10.7084 26.5495 7.625 22 7.625C17.4505 7.625 13.75 10.7084 13.75 14.5C13.75 14.8647 13.6051 15.2144 13.3473 15.4723C13.0894 15.7301 12.7397 15.875 12.375 15.875C12.0103 15.875 11.6606 15.7301 11.4027 15.4723C11.1449 15.2144 11 14.8647 11 14.5C11 9.1925 15.9345 4.875 22 4.875C28.0655 4.875 33 9.1925 33 14.5ZM22 33C21.4561 33 20.9244 33.1613 20.4722 33.4635C20.0199 33.7656 19.6675 34.1951 19.4593 34.6976C19.2512 35.2001 19.1967 35.7531 19.3028 36.2865C19.4089 36.8199 19.6709 37.3099 20.0555 37.6945C20.4401 38.0791 20.9301 38.341 21.4635 38.4472C21.997 38.5533 22.5499 38.4988 23.0524 38.2907C23.5549 38.0825 23.9844 37.7301 24.2865 37.2778C24.5887 36.8256 24.75 36.2939 24.75 35.75C24.75 35.0207 24.4603 34.3212 23.9445 33.8055C23.4288 33.2897 22.7293 33 22 33Z" fill="var(--svg-color)" />
                                </svg>
                            </div>
                            <h2>{t('Confirm Withdrawal Request')}</h2>
                            <h3>{t('This action will initiate a liquidity withdrawal request.')}</h3>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={() => {
                                handleClose4()
                                setRemoveUserLiquidity('')
                            }}>
                                {t('Close')}
                            </button>
                            <button className="Withdraw" onClick={handleRemoveLiquidity}>
                                {t('Confirm')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                className="token"
                show={show5}
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header >
                    <Modal.Title>{t('Withdrawal Request Submitted')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img success-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="34"
                                    height="25"
                                    viewBox="0 0 34 25"
                                    fill="none"
                                >
                                    <path
                                        d="M32.6014 1.35254L11.1178 22.8361L1.35254 13.0708"
                                        stroke="white"
                                        stroke-width="2.70423"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                            <h2>{t('Liquidity Withdrawal Request Submitted')}</h2>

                            {/* <h5>If a round is in progress, your funds will be available for withdrawal after a 2-minute lock-in period. Otherwise, they will be made available to you directly.</h5> */}
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={handleClose5}>
                                {t('Close')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token" show={show6} onHide={handleClose6} centered backdrop="static"
                keyboard={false}
            >
                <Modal.Header >
                    <Modal.Title>{t('Add liquidity')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="new_modals">
                            <div className="liquid_textt">
                                <h2>{t('Liquidity Amount')}</h2>
                                <h2>
                                    {t('Available Balance:')}{" "}
                                    <span>
                                        $
                                        {smartAccountUsdtBalance
                                            ? formatNumbers(+smartAccountUsdtBalance)
                                            : 0}
                                    </span>
                                </h2>
                            </div>
                            <div className="relations">
                                <input

                                    placeholder="$0.00"
                                    type="number"
                                    id="fname"
                                    className={+liquidityAmount >= +smartAccountUsdtBalance && "error"}
                                    name="fname"
                                    value={liquidityAmount}
                                    onChange={(e) => setLiquidityAmount(e.target.value)}
                                />
                                <img
                                    src="\assets\usdt-iconwitharb.svg"
                                    alt="img"
                                    className="img-fluid neww_div"
                                />
                            </div>
                            {+liquidityAmount >= +smartAccountUsdtBalance ? (
                                <h4
                                    style={{
                                        color: "var(--logout-text1)",
                                        fontSize: "12px",
                                        fontFamily: "hbold",
                                        lineHeight: "100%"
                                    }}
                                >
                                    {t('Amount exceeds Available Balance')}
                                </h4>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={() => {
                                handleClose6()
                                setLiquidityAmount('');
                            }}>
                                {t('Cancel')}
                            </button>
                            <button
                                className="Withdraw setbtnsizembl disabled"
                                disabled={+liquidityAmount >= +smartAccountUsdtBalance ||
                                    +liquidityAmount <= 0 ? true : false}
                                onClick={() => {


                                    handleShow7();
                                    handleClose6();

                                }}
                            >
                                {t('Add Liquidity')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token" show={show7} onHide={handleClose7} centered backdrop="static"
                keyboard={false}>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img">
                                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                    <path d="M33 14.5C33 19.4002 28.7942 23.4564 23.375 24.0494V27.875C23.375 28.2397 23.2301 28.5894 22.9723 28.8473C22.7144 29.1051 22.3647 29.25 22 29.25C21.6353 29.25 21.2856 29.1051 21.0277 28.8473C20.7699 28.5894 20.625 28.2397 20.625 27.875V22.75C20.625 22.3853 20.7699 22.0356 21.0277 21.7777C21.2856 21.5199 21.6353 21.375 22 21.375C26.5495 21.375 30.25 18.2916 30.25 14.5C30.25 10.7084 26.5495 7.625 22 7.625C17.4505 7.625 13.75 10.7084 13.75 14.5C13.75 14.8647 13.6051 15.2144 13.3473 15.4723C13.0894 15.7301 12.7397 15.875 12.375 15.875C12.0103 15.875 11.6606 15.7301 11.4027 15.4723C11.1449 15.2144 11 14.8647 11 14.5C11 9.1925 15.9345 4.875 22 4.875C28.0655 4.875 33 9.1925 33 14.5ZM22 33C21.4561 33 20.9244 33.1613 20.4722 33.4635C20.0199 33.7656 19.6675 34.1951 19.4593 34.6976C19.2512 35.2001 19.1967 35.7531 19.3028 36.2865C19.4089 36.8199 19.6709 37.3099 20.0555 37.6945C20.4401 38.0791 20.9301 38.341 21.4635 38.4472C21.997 38.5533 22.5499 38.4988 23.0524 38.2907C23.5549 38.0825 23.9844 37.7301 24.2865 37.2778C24.5887 36.8256 24.75 36.2939 24.75 35.75C24.75 35.0207 24.4603 34.3212 23.9445 33.8055C23.4288 33.2897 22.7293 33 22 33Z" fill="var(--svg-color)" />
                                </svg>
                            </div>
                            <h2>{t('Confirm Liquidity Addition')}</h2>
                            <h3>{t('This action will add funds to the liquidity pool.')}</h3>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={() => {
                                handleClose7()
                                setLiquidityAmount('');

                            }}>
                                {t('Cancel')}
                            </button>
                            <button className="Withdraw" onClick={handleAddLiquidity}>
                                {t('Confirm')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                className="token"
                show={show8}
                onHide={handleClose8}
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header >
                    <Modal.Title>{t('Liquidity Added')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img success-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="34"
                                    height="25"
                                    viewBox="0 0 34 25"
                                    fill="none"
                                >
                                    <path
                                        d="M32.6014 1.35254L11.1178 22.8361L1.35254 13.0708"
                                        stroke="white"
                                        stroke-width="2.70423"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                            <h2>{t('Liquidity Added')}</h2>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={handleClose8}>
                                {t('Close')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token" show={show9} onHide={handleClose9} centered backdrop="static"
                keyboard={false}>
                <Modal.Header >
                    <Modal.Title>{t('Claim Rewards')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal">
                        <div className="inner_side_modal">
                            <h2>{t('Claimable Amount')}</h2>

                            <h3>${userLiquidityWorth ? (+userLiquidityWorth)?.toFixed(4) : "0.00"}</h3>
                        </div>
                        <div className="inner_side_modal1">
                            <button
                                className="close"
                                onClick={() => {
                                    handleClose9();
                                }}
                                disabled={loading}
                            >
                                {t('Close')}
                            </button>
                            <button
                                className="Withdraw"
                                onClick={handleClaimRewards}
                                disabled={+userLiquidityWorth === 0}
                            >
                                {t('Claim')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                className="token"
                show={show10}
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header >
                    <Modal.Title>{t('Success')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img success-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="34"
                                    height="25"
                                    viewBox="0 0 34 25"
                                    fill="none"
                                >
                                    <path
                                        d="M32.6014 1.35254L11.1178 22.8361L1.35254 13.0708"
                                        stroke="white"
                                        stroke-width="2.70423"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                            <h2>{t('Rewards Successfully Claimed')}</h2>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={handleClose10}>
                                {t('Close')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal className="token" show={show1} onHide={handleClose1} centered backdrop="static"
                keyboard={false}>
                <Modal.Body>
                    <div className="one_modal1">
                        <div className="inner_side_modal111">
                            <div className="theme-img">
                                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                    <path d="M33 14.5C33 19.4002 28.7942 23.4564 23.375 24.0494V27.875C23.375 28.2397 23.2301 28.5894 22.9723 28.8473C22.7144 29.1051 22.3647 29.25 22 29.25C21.6353 29.25 21.2856 29.1051 21.0277 28.8473C20.7699 28.5894 20.625 28.2397 20.625 27.875V22.75C20.625 22.3853 20.7699 22.0356 21.0277 21.7777C21.2856 21.5199 21.6353 21.375 22 21.375C26.5495 21.375 30.25 18.2916 30.25 14.5C30.25 10.7084 26.5495 7.625 22 7.625C17.4505 7.625 13.75 10.7084 13.75 14.5C13.75 14.8647 13.6051 15.2144 13.3473 15.4723C13.0894 15.7301 12.7397 15.875 12.375 15.875C12.0103 15.875 11.6606 15.7301 11.4027 15.4723C11.1449 15.2144 11 14.8647 11 14.5C11 9.1925 15.9345 4.875 22 4.875C28.0655 4.875 33 9.1925 33 14.5ZM22 33C21.4561 33 20.9244 33.1613 20.4722 33.4635C20.0199 33.7656 19.6675 34.1951 19.4593 34.6976C19.2512 35.2001 19.1967 35.7531 19.3028 36.2865C19.4089 36.8199 19.6709 37.3099 20.0555 37.6945C20.4401 38.0791 20.9301 38.341 21.4635 38.4472C21.997 38.5533 22.5499 38.4988 23.0524 38.2907C23.5549 38.0825 23.9844 37.7301 24.2865 37.2778C24.5887 36.8256 24.75 36.2939 24.75 35.75C24.75 35.0207 24.4603 34.3212 23.9445 33.8055C23.4288 33.2897 22.7293 33 22 33Z" fill="var(--svg-color)" />
                                </svg>
                            </div>
                            <h2>{t('Confirm Withdrawal Request')}</h2>
                            <h3>{t('This action will initiate a liquidity withdrawal request.')}</h3>
                        </div>
                        <div className="inner_side_modal1">
                            <button className="close" onClick={() => {
                                handleClose1()
                            }}>
                                {t('Close')}
                            </button>
                            <button className="Withdraw" onClick={unreserved}>
                                {t('Confirm')}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Liquidity;